<template>
  <div id="explainer-videos">
    <v-row class="text-center d-flex justify-center">
      <v-col class="mb-16" cols="10">
        <div class="py-8"></div>
        <h3 class="mb-6 display-1">
          Scopri di piú
        </h3>

        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-card @click="openVideo('trailer')">
              <v-img
                :src="require('@/assets/trailer.jpg')"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                 >
                <v-card-title>Trailer</v-card-title>
              </v-img>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-card @click="openVideo('faq')">
              <v-img
                :src="require('@/assets/faq.jpg')"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                >
                <v-card-title>FAQ</v-card-title>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
     <v-divider></v-divider>

    <!-- DIALOG -->
    <VideoPlayerInDialog  v-model="videoDialogOpen" :video="selectedVideo" :videotitle="selectedVideoTitle" :key="videoToPlayId" />
  </div>
</template>

<script>
export default {
  name: "ExplainerVideos",

  components: {
    VideoPlayerInDialog: () => import("@/components/misc/VideoPlayerInDialog"),
  },

  data() {
    return {
      videoDialogOpen: false,
      selectedVideo: null,
      selectedVideoTitle: null,
      videoToPlayId: 0,
      
      togetherTrailer: [
        { 
          resolution: "360p",
          src: "https://player.vimeo.com/external/504312097.sd.mp4?s=983344d708f61f198bcfa8afe562e5625d885e2e&profile_id=164"
        },
        { 
          resolution: "540p",
          src: "https://player.vimeo.com/external/504312097.sd.mp4?s=983344d708f61f198bcfa8afe562e5625d885e2e&profile_id=165"
        },
        { 
          resolution: "720p",
          src: "https://player.vimeo.com/external/504312097.hd.mp4?s=a35905ee857313856f0ffc00d8f5ef41361e6e3a&profile_id=174"
        }
      ],

      togetherFAQ: [
        { 
          resolution: "360p",
          src: "https://player.vimeo.com/external/504312908.sd.mp4?s=195779778d9e8e8b241aee7e94e996684d16e892&profile_id=164"
        },
        { 
          resolution: "540p",
          src: "https://player.vimeo.com/external/504312908.sd.mp4?s=195779778d9e8e8b241aee7e94e996684d16e892&profile_id=165"
        },
        { 
          resolution: "720p",
          src: "https://player.vimeo.com/external/504312908.hd.mp4?s=04662d3a925512863b96b1e347043223a50bde1e&profile_id=174"
        }
      ]
    };
  },

  methods: {
    openVideo(name){
      this.videoToPlayId = this.videoToPlayId + 1
      this.selectedVideoTitle = name
      if(name == 'faq'){
        this.selectedVideo = this.togetherFAQ 
      } else {
        this.selectedVideo = this.togetherTrailer
      }
      this.videoDialogOpen = true
    }
  },

  created(){
  }
};
</script>

